// ====================================================================
// ziven-theme-aura v0.2.5f forum/index.js
// ====================================================================
//
// 移动端 Drawer + 桌面端 Sidebar (隐藏) 改版主入口
// - modifyDrawer: 移动端 (< 992px) drawer 模式, 注入 user-block + 5 stats + nav
// - modifySidebar: 桌面端 (>= 992px) sidebar 模式 (辉哥 15:10 拍板隐藏, 代码保留)
// - modifyNavItems: 美化 vendor + 扩展注入的 nav item
// - modifyHeaderSecondary: 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (v0.2.3 新)
// - mobileComposer: 移动端 (< 992px) 帖子页 composer 改 fixed bottom 仿小黑盒 (v0.2.5f 新)
//
// Flarum 2.0 vendor namespace:
//   - flarum/forum/components/HeaderPrimary (扩展点, vendor 默认空 ItemList)
//   - flarum/forum/components/HeaderSecondary (vendor 默认有 search + locale + logIn, 我们隐藏 .Search)
//   - flarum/common/components/Avatar (Flarum 原生 Avatar 组件)
//   - flarum/common/components/Badge / GroupBadge (原生 .Badge 组件, 复用 ziven-core 颜色)
//   - flarum/forum/components/Composer (lazy chunk 366 module 8139, SOP 280 走 flarum.reg.onLoad,
//      v0.2.5f mobileComposer override Composer.view 仿小黑盒)
//
// v0.2.3 关键改动 (辉哥 15:10 拍板):
//   - 桌面端 sidebar 容器 (>= 992px) CSS display: none 隐藏 (代码保留)
//   - 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (跟 ziven.ski 1:1)
//   - 桌面端 header-secondary 整体图标样式跟 ziven.ski 真实 1:1
//   - App-content 顶部 "发布讨论" 按钮保留 (辉哥说不删)
//   - 移动端 < 992px 不动 (drawer 模式保持现状)
//
// v0.2.5f 关键改动 (辉哥 21:43 大返工, 移动端 composer 改 fixed bottom 仿小黑盒):
//   - zpc v0.1.0e.k 系列全 revert (回到 e.j 状态), 避免跟 ziven-theme-aura 双管辖
//   - mobileComposer: override Composer.view 重写移动端 vnode
//     - 桌面端 (>= 992px) 走 vendor 默认
//     - 移动端 (< 992px) 完全重写 vnode, 仿小黑盒 default 80px / focused 140px
//   - 配套 less/forum.less v0.2.5f 段: .ziven-composer-mobile + .ziven-composer-default +
//     .ziven-composer-focused + 4 input-tool + 8 emoji 工具条
//   - 范围: 只 DiscussionPage 移动端 composer, 桌面端保留 vendor 默认. 帖子本身样式不动
// ====================================================================

import app from 'flarum/common/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import modifyDrawer from './modifyDrawer';
import modifySidebar from './modifySidebar';
import modifyNavItems from './modifyNavItems';
import modifyHeaderSecondary from './modifyHeaderSecondary';
import mobileComposer from './mobileComposer';
app.initializers.add('ziiven-theme-aura', () => {
  // 1. 移动端 drawer 注入 (user-block + 5 stats + nav)
  modifyDrawer();

  // 2. 桌面端 sidebar 注入 (辉哥 15:10 拍板: 桌面端隐藏, 代码保留, CSS display: none)
  modifySidebar();

  // 3. 美化 nav item (vendor + 扩展注入的, 不主动加)
  modifyNavItems();

  // 4. 桌面端 HeaderSecondary 注入 "发布主题" 蓝底方按钮 (v0.2.3 新)
  modifyHeaderSecondary();

  // 5. v0.2.5f 移动端 composer 改 fixed bottom 仿小黑盒 (辉哥 21:43 大返工)
  // 范围: DiscussionPage 移动端 composer. 桌面端走 vendor 默认
  mobileComposer();

  // 6. HeaderPrimary 扩展点 (vendor 兼容, 给其他扩展留接口)
  extend(HeaderPrimary.prototype, 'items', function (items) {
    // v0.2.0 移动端 + 桌面端共用 vendor HeaderPrimary.items() ItemList
    // nav item 由 modifyNavItems.js 主动加 (5 主体 + 1 separator + 3 账号)
  });
});